import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "340",
  "slug": "spot-finland-from-satellite-imagery",
  "title": "How to Recognise Finland in Satellite Images",
  "excerpt": "Southern and central Finland contain extensive mosaics of forest and lakes.",
  "date": "2026-06-03",
  "category": "Geography",
  "image": "/blog-images/finland.jpg",
  "readTime": "1 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Southern and central Finland contain extensive mosaics of forest and lakes. The broken southwest coast opens into an archipelago, while the Gulf of Bothnia and Gulf of Finland help orient a regional view. These water bodies provide stronger anchors than a forested crop on its own."
    },
    {
      "type": "heading",
      "text": "Checking the location"
    },
    {
      "type": "paragraph",
      "text": "Compare the pattern with Sweden and northwestern Russia, which also have glaciated terrain and many lakes. A small patch of water and conifer forest may remain ambiguous. Trace a shoreline or a connected lake system to a named feature before deciding. Snow and lake ice can hide the distinctions you would use in a summer image."
    }
  ],
  "imageAlt": "Finland regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
